import styled from 'styled-components';

import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $MainTitle = styled.div`
  font-size: ${({ theme }) => theme.tw.font.size['2xl']};
  color: ${({ theme }) => theme.newUI.defaultColors.text};
  font-weight: ${fontWeight('bold')};
  margin-bottom: ${spacing(5)};
`;

export const $MainDescription = styled.div`
  ${fontStyle('base')};
  color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
`;

export const $Footer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${spacing(10)};
`;
